import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';

import StudentForm from '../components/student/StudentForm';
import { createStudent } from '../actions/studentActions';
import { getBids } from '../actions/bidActions';
import { getAgreements } from '../actions/agreementActions';
import { countriesArray } from '../constants/countries';
import { toSelect } from '../utils/helpers';
import '../styles/new-student.scss';

class NewStudentPage extends Component {
  constructor() {
    super();

    this.state = { countries: [] };
  }

  componentWillMount() {
    const { getBids, getAgreements, bids, agreements } = this.props;
    _.isEmpty(bids) && getBids();
    _.isEmpty(agreements) && getAgreements();
    const countries = countriesArray();
    this.setState({ countries });
  }

  render() {
    const { bids, agreements, createStudent } = this.props;
    const { countries } = this.state;
    const initialValues = {
      admissionDate: moment().format('YYYY-MM-DD'),
      nationality: 'Uruguay'
    };

    return (
      <div id="new-student">
        <h4>INGRESAR NUEVO ALUMNO</h4>
        <StudentForm
          initialValues={initialValues}
          onSubmit={createStudent}
          bids={toSelect(bids)}
          agreements={toSelect(agreements)}
          countries={countries}
          submitText="Ingresar Alumno"
        />
      </div>
    );
  }
}

const { func, array } = PropTypes;

NewStudentPage.propTypes = {
  createStudent: func.isRequired,
  getBids: func.isRequired,
  getAgreements: func.isRequired,
  bids: array.isRequired,
  agreements: array.isRequired
};

const mapState = state => ({
  bids: state.get('bid').toJS(),
  agreements: state.get('agreement').toJS()
});

const mapDispatch = dispatch => ({
  createStudent: student => dispatch(createStudent(student.toJS())),
  getBids: () => dispatch(getBids()),
  getAgreements: () => dispatch(getAgreements())
});

export default connect(mapState, mapDispatch)(NewStudentPage);



// WEBPACK FOOTER //
// ./src/containers/NewStudentPage.js